import styles from "../start.module.scss";

export type TermsSectionProps = {
  title: string;
  text: string;
  className?: string;
  titleClassName?: string;
  textClassName?: string;
};

export default function TermsSection({
  title,
  text,
  className = "",
  titleClassName = "fwb f-4",
  textClassName = `${styles.terms} fwn f-4 lh-4`,
}: TermsSectionProps) {
  return (
    <div className={className}>
      <div
        className={titleClassName}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div
        className={textClassName}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}
